{
  "chat": {
    "title": "Chat",
    "empty": "Nessuna chat",
    "loadError": "Impossibile caricare questa conversazione",
    "messagePlaceholder": "Messaggio",
    "typing": "{{name}} sta scrivendo…",
    "typingTwo": "{{a}} e {{b}} stanno scrivendo…",
    "typingMany": "Più persone stanno scrivendo…",
    "online": "Online",
    "offline": "Offline",
    "unread": "Non letto",
    "startDm": "Invia un messaggio a {{name}}",
    "members": "Membri",
    "mute": "Silenzia questa conversazione",
    "unmute": "Riattiva questa conversazione",
    "muted": "Silenziata"
  },
  "login": {
    "title": "Bentornato!",
    "description": "Inserisci il tuo indirizzo email e ti invieremo un codice per accedere.",
    "input": {
      "label": "Indirizzo email",
      "placeholder": "me@email.com"
    },
    "button": {
      "label": "Richiedi codice",
      "loading": "Invio codice..."
    }
  },
  "verify": {
    "title": "Inserisci codice",
    "description": "Inserisci il codice che ti abbiamo inviato via email a {{email}}.",
    "input": {
      "label": "Codice di verifica",
      "placeholder": "00000000"
    },
    "button": {
      "label": "Verifica codice",
      "loading": "Verifica in corso..."
    },
    "buttonAbort": {
      "label": "Annulla"
    },
    "buttonResend": {
      "label": "Reinvia codice"
    },
    "error": {
      "Invalid or expired OTP.": "Il codice è scaduto o non valido.",
      "invalidOtp": "Il codice è scaduto o non valido."
    }
  },
  "date": "{{value, datetime}}",
  "auth": {
    "logout": {
      "button": "Esci",
      "confirmTitle": "Esci",
      "confirmMessage": "Sei sicuro di voler uscire?",
      "error": "Disconnessione fallita. Riprova."
    }
  },
  "errors": {
    "types": {
      "authentication": "Errore di autenticazione",
      "network": "Problema di connessione",
      "generic": "Qualcosa è andato storto"
    },
    "messages": {
      "sessionExpired": "La tua sessione è scaduta. Effettua nuovamente l'accesso.",
      "networkError": "Controlla la tua connessione internet e riprova.",
      "genericError": "Si è verificato un errore imprevisto. Puoi provare ad aggiornare la pagina o disconnetterti.",
      "noOrg": "Nessuna organizzazione trovata..."
    },
    "technical": {
      "title": "Dettagli tecnici:",
      "retryAttempts": "Tentativi: {{current}}/{{max}}"
    },
    "actions": {
      "tryAgain": "Riprova",
      "loginAgain": "Accedi di nuovo",
      "logout": "Esci",
      "moreOptions": "Altre opzioni",
      "chooseAction": "Scegli un'azione:",
      "refreshApp": "Aggiorna app",
      "debugData": "Dati di debug",
      "clearCacheRetry": "Svuota cache e riprova"
    }
  },
  "common": {
    "currency": "{{value, currency}}",
    "decimalSeparator": ",",
    "loading": "Caricamento...",
    "cancel": "Annulla",
    "confirm": "Conferma",
    "error": "Errore",
    "success": "Successo",
    "time": {
      "dayAgo": "1 giorno fa",
      "daysAgo": "{{count}} giorni fa",
      "weekAgo": "1 settimana fa",
      "weeksAgo": "{{count}} settimane fa",
      "monthsAgo": "{{count}} mesi fa",
      "secondsAbbr": "s"
    },
    "profile": "Profilo"
  },
  "dashboard": {
    "error": {
      "orgNotFound": "Organizzazione non trovata"
    },
    "quickActions": {
      "media": {
        "title": "Tutti i media",
        "subtitle": "Sfoglia la libreria"
      },
      "achievements": {
        "title": "Traguardi",
        "subtitle": "Visualizza progressi"
      },
      "profile": {
        "title": "Tessera socio",
        "subtitle": "I tuoi dettagli"
      },
      "membership": {
        "title": "Abbonamento",
        "subtitle": "Visualizza piano"
      },
      "offers": {
        "title": "Offerte",
        "subtitle": "Sfoglia disponibili"
      },
      "invite": {
        "title": "Invita membri",
        "subtitle": "Crea codice QR"
      }
    },
    "sections": {
      "featuredVideos": "Video in evidenza",
      "lastViewed": "Visti di recente",
      "bookmarkedVideos": "Elementi salvati",
      "recentAchievements": "Traguardi recenti",
      "viewAllAction": "Mostra tutto"
    }
  },
  "membership": {
    "paymentRequired": {
      "title": "Configurazione del pagamento richiesta",
      "subtitle": "Il tuo abbonamento è stato trasferito a questa organizzazione. Per continuare, configura il pagamento con uno dei metodi di pagamento disponibili.",
      "paidUntilNote": "Il periodo già pagato viene mantenuto — non ti verrà addebitato nulla prima del {{date}}.",
      "bonusOffer_one": "Configura il tuo pagamento entro il {{date}} e ricevi {{count}} mese bonus in regalo.",
      "bonusOffer_other": "Configura il tuo pagamento entro il {{date}} e ricevi {{count}} mesi bonus in regalo.",
      "openDashboard": "Configura il pagamento nella dashboard web",
      "openDashboardHint": "Per motivi di sicurezza, la configurazione del pagamento avviene nel browser. Verrai connesso automaticamente.",
      "checkAgain": "Ho completato il pagamento",
      "error": "Impossibile avviare la configurazione del pagamento. Riprova."
    },
    "codeOfConduct": {
      "heading": "Codice di condotta",
      "subtitle": "Leggi il testo seguente e accettalo per continuare a usare questa organizzazione.",
      "acceptLabel": "Ho letto e accetto «{{title}}».",
      "accept": "Accetta",
      "acceptError": "Non è stato possibile salvare il tuo consenso. Riprova.",
      "loadError": "Non è stato possibile caricare il testo.",
      "retry": "Riprova",
      "newVersion": "Ora è in vigore una nuova versione. Leggila e accettala."
    },
    "title": "Abbonamento",
    "status": {
      "active": "Attivo",
      "inactive": "Inattivo"
    },
    "period": {
      "monthly": "Mensile",
      "yearly": "Annuale"
    },
    "pricing": {
      "per": {
        "monthly": "al mese",
        "yearly": "all'anno"
      }
    },
    "sections": {
      "planDetails": "Dettagli",
      "organization": "Organizzazione"
    },
    "labels": {
      "billingPeriod": "Periodo di fatturazione",
      "memberSince": "Membro dal",
      "validUntil": "Valido fino al",
      "cancelled": "Abbonamento annullato"
    },
    "organization": {
      "memberDescription": "Sei membro di questa organizzazione"
    },
    "management": {
      "title": "Gestisci il tuo abbonamento",
      "description": "Per apportare modifiche al tuo abbonamento, utilizza la WebApp OctaHub o contatta direttamente {{organizationName}}."
    },
    "dashboard": {
      "title": "Apri dashboard",
      "subtitle": "Gestisci il tuo abbonamento e le impostazioni",
      "openError": "Impossibile aprire la dashboard. Riprova."
    }
  },
  "media": {
    "download": {
      "button": "Scarica",
      "available": "Disponibile offline"
    },
    "screens": {
      "bookmarks": "Video salvati",
      "lastViewed": "Video visti di recente",
      "library": "Media"
    },
    "bookmark": {
      "save": "Salva",
      "saved": "Salvato",
      "bookmarkLabel": "Segnalibro",
      "bookmarkedLabel": "Salvato"
    },
    "folder": {
      "itemCount_one": "{{count}} elemento",
      "itemCount_other": "{{count}} elementi",
      "folderDescription": "Cartella con {{count}} elementi"
    },
    "sharedFolders": {
      "upload": "Carica",
      "newFolder": "Nuova cartella",
      "folderNamePlaceholder": "Nome cartella...",
      "uploading": "Caricamento...",
      "uploadProgress": "{{progress}}%",
      "uploadSuccess": "File caricato con successo",
      "uploadError": "Caricamento fallito",
      "uploadErrorMessage": "Si è verificato un errore durante il caricamento. Riprova.",
      "uploadSubtitle": "Carica un file in questa cartella",
      "newFolderSubtitle": "Crea una nuova sottocartella"
    },
    "navigation": {
      "previous": "Precedente",
      "next": "Successivo"
    },
    "relatedVideos": "Contenuti correlati",
    "delete": {
      "button": "Elimina",
      "confirmTitle": "Elimina media",
      "confirmMessage": "Sei sicuro di voler eliminare questo elemento? Questa azione non può essere annullata.",
      "success": "Media eliminato con successo",
      "error": "Eliminazione fallita",
      "errorMessage": "Impossibile eliminare questo media. Riprova.",
      "errorInUse": "Questo media è utilizzato in una o più offerte e non può essere eliminato."
    }
  },
  "achievements": {
    "title": "Traguardi",
    "subtitle": "I tuoi traguardi raggiunti",
    "count_zero": "Nessun traguardo raggiunto",
    "count_one": "{{count}} traguardo raggiunto",
    "count_other": "{{count}} traguardi raggiunti",
    "earned": "Ottenuto {{time}}",
    "emptyState": {
      "title": "Nessun traguardo ancora",
      "description": "Completa corsi e attività per ottenere il tuo primo traguardo!"
    }
  },
  "noOrg": {
    "title": "Nessuna organizzazione trovata",
    "description": "Non hai ancora accesso a nessuna organizzazione. Contatta il tuo amministratore per ottenere l'accesso o riprova più tardi.",
    "actions": {
      "title": "Cosa puoi fare:",
      "contactAdmin": "Contatta l'amministratore della tua organizzazione",
      "askInvitation": "Richiedi un invito",
      "checkAccount": "Verifica di usare l'account corretto",
      "tryRelogin": "Prova a disconnetterti e riconnetterti"
    }
  },
  "offers": {
    "title": "Offerte",
    "detailsTitle": "Dettagli offerta",
    "notFound": "Offerta non trovata",
    "notFoundMessage": "Questa offerta non è stata trovata",
    "noOffers": "Nessuna offerta disponibile al momento",
    "purchased": "Acquistato",
    "free": "Gratuito",
    "purchaseWebOnly": "Acquisto solo tramite web-app",
    "claimOffer": "Riscatta offerta",
    "purchase": "Acquista",
    "purchasedBadge": "✓ Possiedi già questa offerta",
    "youOwnThis": "Hai accesso a tutti i contenuti di questa offerta",
    "missingAchievements": "⚠️ Non hai i traguardi richiesti per questa offerta. Ti mancano ancora: {{missing}}",
    "mobileNotAvailable": "⚠️ Gli acquisti non sono disponibili nell'app mobile",
    "mobileNotAvailableSubtext": "Visita il nostro sito web per acquistare questa offerta",
    "price": "Prezzo:",
    "includedContent": "Contenuti inclusi",
    "includedAchievements": "Traguardi inclusi",
    "videoCount_one": "{{count}} video",
    "videoCount_other": "{{count}} video",
    "audioCount_one": "{{count}} audio",
    "audioCount_other": "{{count}} audio",
    "pdfCount_one": "{{count}} PDF",
    "pdfCount_other": "{{count}} PDF",
    "documentCount_one": "{{count}} documento",
    "documentCount_other": "{{count}} documenti",
    "imageCount_one": "{{count}} immagine",
    "imageCount_other": "{{count}} immagini",
    "achievementCount_one": "{{count}} traguardo",
    "achievementCount_other": "{{count}} traguardi",
    "paymentDenied": {
      "title": "Pagamento non disponibile",
      "description": "Questa offerta non è disponibile per l'acquisto nella tua regione"
    },
    "pricing": {
      "netAmount": "Importo netto"
    },
    "errors": {
      "general": "Errore",
      "purchaseFailed": "Elaborazione dell'acquisto fallita",
      "webOnly": "Gli acquisti sono disponibili solo nella versione web"
    },
    "success": {
      "claimed": "Offerta riscattata con successo!"
    },
    "paymentProviders": {
      "selectTitle": "Seleziona metodo di pagamento",
      "selectSubtitle": "Scegli come vuoi pagare",
      "stripe": {
        "name": "Stripe",
        "description": "Carta di credito, carta di debito, Apple Pay, Google Pay"
      },
      "paypal": {
        "name": "PayPal",
        "description": "Saldo PayPal, carta di credito, conto bancario"
      }
    },
    "payment": {
      "processing": "Elaborazione del pagamento...",
      "success": {
        "title": "Pagamento riuscito!",
        "message": "Il tuo acquisto è stato completato con successo. Ora hai accesso al contenuto.",
        "viewOffer": "Visualizza offerta",
        "backToOffers": "Torna alle offerte"
      },
      "pending": {
        "title": "Pagamento in elaborazione",
        "message": "Il tuo pagamento è ancora in fase di elaborazione. Potrebbe richiedere qualche istante...",
        "checkStatus": "Controlla stato"
      },
      "failed": {
        "title": "Pagamento fallito",
        "message": "Il tuo pagamento non è andato a buon fine. Riprova.",
        "tryAgain": "Riprova"
      }
    }
  },
  "orgSelection": {
    "title": "Seleziona organizzazione",
    "subtitle": "Scegli un'organizzazione per continuare",
    "switchOrg": "Cambia organizzazione",
    "switchOrgSubtitle": "Passa a un'altra organizzazione",
    "currentOrg": "Attuale"
  },
  "profile": {
    "myPurchases": "I miei acquisti",
    "idPrefix": "ID: "
  },
  "settings": {
    "language": {
      "title": "Lingua",
      "subtitle": "Seleziona la tua lingua preferita",
      "systemDefault": "Predefinita di sistema"
    },
    "notifications": {
      "title": "Notifiche",
      "subtitle": "Scegli di cosa vuoi essere notificato",
      "chat": "Messaggi della chat",
      "chatHint": "Ricevi una notifica per i nuovi messaggi nelle tue conversazioni",
      "seeAll": "Vedi tutte le notifiche",
      "permissionDenied": "Le notifiche per questa app sono disattivate nelle impostazioni del dispositivo."
    }
  },
  "openWebApp": "Apri Web App",
  "openWebAppSubtext": "Gestisci il tuo account, gli acquisti e altro su {{url}}",
  "openWebAppError": "Impossibile aprire la web app. Riprova.",
  "invite": {
    "title": "Invita membri",
    "selectPlan": "Seleziona un piano di adesione",
    "selectGroup": "Seleziona un gruppo",
    "generating": "Generazione in corso...",
    "scanToJoin": "Scansiona questo codice QR per unirti",
    "createAnother": "Creane un altro",
    "error": {
      "createFailed": "Impossibile creare l'invito. Riprova.",
      "noPlans": "Nessun piano di adesione disponibile."
    }
  },
  "notifications": {
    "title": "Notifiche",
    "empty": "Nessuna notifica",
    "markAllRead": "Segna tutte come lette",
    "unread": "Non letta",
    "loadError": "Impossibile caricare le notifiche",
    "chat": {
      "messageGroup": {
        "title": "{{channel}}",
        "body": "{{sender}}: {{preview}}"
      },
      "messageDm": {
        "title": "{{sender}}",
        "body": "{{preview}}"
      }
    },
    "common": {
      "newMessage": "Nuovo messaggio"
    }
  }
}
